/**
 * @file thunder日志
 */
export default class Thunder {
    constructor(key, base = {}) {
        this.targetUrl = '//hpd.baidu.com/v.gif';

        this.baseLog = {
            ct: 3,
            cst: 0,
            logInfo: '',
            logFrom: '',
            logExtra: null,
            // 获取
            logid: '', // 串联logid
            // 时间戳
            tn: '',
            ctn: '',
            imei: '',
            cuid: '',
            os: '',
            osbranch: '',
            ua: '',
            ut: '',
            apiv: '',
            appv: '',
            version: '',
            life: '',
            clife: '',
            network: ''
        };
        this.logConf = Object.assign(this.baseLog, base);
    }

    config(opps) {
        this.logConf = Object.assign(this.logConf, opps);
    }

    send(logInfoParam) {
        let logInfo = logInfoParam;
        if (this.logConf.check) {
            logInfo = this.logConf.check(logInfo);
        }

        if (logInfo.logExtra instanceof Array) {
            logInfo.logExtra = logInfo.logExtra.map(logExtra => Object.assign({}, this.logConf.logExtra, logExtra));
        }
        else {
            logInfo.logExtra = Object.assign({}, this.logConf.logExtra, logInfo.logExtra);
        }

        if (logInfo.cst === 1 && !(logInfo.logExtra instanceof Array)) {
            logInfo.logExtra = [logInfo.logExtra];
        }
        const data = Object.assign({}, this.logConf, logInfo);
        if (logInfo.ct && logInfo.ct === 3) {
            data.r = Date.now();
        }
        else {
            data.clife = Date.now();
        }

        const logArr = [];
        Object.keys(data).map(item => {
            if (Object.prototype.hasOwnProperty.call(data, item)) {
                if (data[item] !== undefined) {
                    if (typeof data[item] === 'object') {
                        logArr.push(`${item}=${encodeURIComponent(JSON.stringify(data[item]))}`);
                    }
                    else {
                        logArr.push(`${item}=${encodeURIComponent(data[item])}`);
                    }
                }
            }
            return false;
        });
        const logStr = logArr.join('&');
        let img = new Image();
        const imgFn = () => {
            img.onload = null;
            img.onerror = null;
            img.onabort = null;
            img = null;
        };
        img.onload = imgFn;
        img.onerror = imgFn;
        img.onabort = imgFn;
        img.src = `${this.targetUrl}?${logStr}`;
    }
}
